import axiosInstance from '../axiosInterceptor/axiosInstance'

// With an orgId the player is read under that org's route; without one, under the Org-Id header.
const getPlayer = async (data) => {
  const { playerId, orgId } = data
  const url = orgId ? `v1/orgs/${orgId}/players/${playerId}` : `players/${playerId}`
  const response = await axiosInstance.get(url)
  return response?.data
}

export default getPlayer
